import { useState } from "react";
import { Body1, Button, MessageBar, MessageBarBody, Title3, makeStyles, tokens } from "@fluentui/react-components";
import { WrenchScrewdriver24Regular } from "@fluentui/react-icons";
import { signIn } from "../auth/msal";

const useStyles = makeStyles({
  root: {
    minHeight: "100dvh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    gap: tokens.spacingVerticalL,
    padding: tokens.spacingHorizontalXL,
    boxSizing: "border-box",
  },
  icon: { fontSize: "40px", color: tokens.colorBrandForeground1 },
});

/** Primo accesso fuori da Teams: il popup di login parte dal clic, quindi il browser non lo blocca. */
export function SignIn({ onDone }: { onDone: () => void }) {
  const s = useStyles();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();

  async function go() {
    setBusy(true);
    setError(undefined);
    try {
      await signIn();
      onDone();
    } catch (e) {
      const msg = e instanceof Error ? e.message : String(e);
      setError(
        msg.includes("popup_window_error") || msg.includes("empty_window_error")
          ? "Il browser ha bloccato la finestra di accesso. Consenti i popup per questo sito e riprova."
          : msg.includes("user_cancelled")
            ? "Accesso annullato."
            : msg,
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className={s.root}>
      <WrenchScrewdriver24Regular className={s.icon} />
      <Title3>Richieste di acquisto</Title3>
      <Body1>Accedi con il tuo account di lavoro per continuare.</Body1>
      <Button appearance="primary" size="large" onClick={go} disabled={busy}>
        {busy ? "Accesso in corso…" : "Accedi con Microsoft"}
      </Button>
      {error && (
        <MessageBar intent="error">
          <MessageBarBody>{error}</MessageBarBody>
        </MessageBar>
      )}
    </div>
  );
}
